import React, { useContext, useEffect, useMemo, useState } from "react";
import Tab from "./Tab";
import SidePanel from "./SidePanel";
import AppContext from "../../Store/AppContext";
const Tabs = ({
  children,
  keepMounted = false,
  navigationDetails = {},
  setNavigationDetails,
}) => {
  const tabs = useMemo(() => React.Children.toArray(children), [children]);
  const [activeTab, setActiveTab] = useState(tabs[0]?.props?.label);
  const [mountedTabs, setMountedTabs] = useState(() => {
    const firstLabel = tabs[0]?.props?.label;
    return new Set(firstLabel ? [firstLabel] : []);
  });
  const { productCode, clientDetails, regulationCode } = useContext(AppContext);
  const subscribedProcucts = clientDetails?.dataAccess ?? {};
  const defaultProductCode = Object.keys(subscribedProcucts)?.[0] ?? null;

  const [regulationName, setRegulationName] = useState("");
  const onClickTabItem = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {
    if (
      tabs.length > 0 &&
      (!activeTab || !tabs.some((tab) => tab.props?.label === activeTab))
    ) {
      setActiveTab(tabs[0]?.props?.label);
    }
  }, [activeTab, tabs]);

  useEffect(() => {
    if (keepMounted && activeTab) {
      setMountedTabs((prev) => {
        if (prev.has(activeTab)) return prev;
        const next = new Set(prev);
        next.add(activeTab);
        return next;
      });
    }
  }, [activeTab, keepMounted]);

  useEffect(() => {
    if (
      navigationDetails?.time !== "" &&
      Object.keys(navigationDetails).length > 0
    ) {
      // navigationDetails?.to return tab label where to navigate
      setActiveTab(navigationDetails?.to);
    }
  }, [navigationDetails?.time]);

  useEffect(() => {
    if (
      Object.keys(navigationDetails).length > 0 &&
      activeTab !== navigationDetails?.to
    ) {
      setNavigationDetails({});
    }
  }, [activeTab]);

  const handleRegulationName = () => {
    setRegulationName(localStorage.getItem("regulationName"));
    if (
      localStorage.getItem("regulationName") === null ||
      localStorage.getItem("regulationName") === ""
    ) {
      switch (defaultProductCode) {
        case "P001":
          return setRegulationName("UK MIFID II Record Keeping");
        case "P004":
          return setRegulationName("EU MIFID II Record Keeping");
        case "P002":
          return setRegulationName("UK Communication Records");
        case "P005":
          return setRegulationName("EU Communication Records");
        default:
          return null;
      }
    } else {
      // return setRegulationName(localStorage.getItem('regulationName'));
      switch ((productCode, regulationCode)) {
        case "P001":
          return setRegulationName("UK MIFID II Record Kepping");
        case "P004":
          return setRegulationName("EU MIFID II Record Keeping");
        case "P002":
          return setRegulationName("UK Communication Records");
        case "P005":
          return setRegulationName("EU Communication Records");
        case "ROO5":
          return setRegulationName("UK FIRDS");
        case "ROO6":
          return setRegulationName("EU FIRDS");
        case "ROO7":
          return setRegulationName("UPI");
        case "ROO8":
          return setRegulationName("GLIFE");
        default:
          return null;
      }
    }
  };
  useEffect(() => {
    handleRegulationName();
  }, [productCode]);

  return (
    <div className="tabs">
      <ul className="tab-list m-0">
        <SidePanel />
        <div class="vertical-line" />
        {tabs.map((child) => {
          const { label } = child.props;
          return (
            <Tab
              key={label}
              label={label}
              activeTab={activeTab}
              onClick={onClickTabItem}
            />
          );
        })}
        <div
          className="regulation-name"
          style={{
            marginLeft: "auto",
            float: "right",
            whiteSpace: "nowrap",
            marginRight: "12px",
          }}
        >
          <p style={{ marginBottom: "0px", fontSize: "13px", color: "white" }}>
            {regulationName}
          </p>
        </div>
      </ul>
      <div className="tab-content  ">
        {tabs.map((child) => {
          const { label } = child.props;
          const isActive = label === activeTab;

          const contentWithActiveProp = React.Children.map(
            child.props.children,
            (node) => {
              if (!React.isValidElement(node)) return node;
              return React.cloneElement(node, { isActive });
            },
          );

          if (keepMounted) {
            if (!mountedTabs.has(label)) return null;
            return (
              <div key={label} style={{ display: isActive ? "block" : "none" }}>
                {contentWithActiveProp}
              </div>
            );
          }

          if (!isActive) return null;
          return <div key={label}>{contentWithActiveProp}</div>;
        })}
      </div>
    </div>
  );
};

export default Tabs;
